/**
 * hoverCell.ts - Visibility of the hover affordances rendered on the cell under the pointer.
 *
 * The hover cell is hidden while the user is typing so the affordances do not sit under the
 * pointer, and shown again on the next pointer move.
 */

import type {TableMutationParams} from 'notebook/tables/store/logic/mutations/mutationParams';

/**
 * Hide the hover affordances on the cell under the pointer.
 *
 * No-op when they are already hidden, so a held-down key does not write to the store on every
 * repeat.
 */
export function hideHoverCell(params: TableMutationParams): void {
  if (!params.getTableModel().state.hideHoverCell) {
    params.setState({hideHoverCell: true});
  }
}

/**
 * Show the hover affordances on the cell under the pointer.
 *
 * No-op when they are already shown, so pointer movement does not write to the store on every
 * event.
 */
export function showHoverCell(params: TableMutationParams): void {
  if (params.getTableModel().state.hideHoverCell) {
    params.setState({hideHoverCell: false});
  }
}
